<template>
  <div>
    <SlimNavbar></SlimNavbar>
    <d-container fluid>
      <d-row>
        <!-- Main Sidebar -->
        <main-sidebar :items="sidebarItems" :showSidebar="showSidebar"/>

        <d-col
          class="main-content offset-xl-2 offset-md-3 p-0"
          tag="main"
          xl="10"
          md="9"
          sm="12"
        >
          <!-- Main Navbar -->
          <main-navbar @toggleSidebar="handleToggleSidebar" />

          <!-- Content -->
          <slot />

          <!-- Main Footer -->
          <main-footer />
        </d-col>
      </d-row>
    </d-container>
  </div>
</template>

<script>
import getSidebarItems from "@/data/sidebar-nav-items";

// Main layout components
import MainNavbar from "@/components/layout/MainNavbar/MainNavbar.vue";
import MainSidebar from "@/components/layout/MainSidebar/MainSidebar.vue";
import MainFooter from "@/components/layout/MainFooter/MainFooter.vue";
import SlimNavbar from "@/components/layout/MainNavbar/SlimNavbar.vue";

export default {
  name: "default",
  components: {
    MainNavbar,
    MainSidebar,
    MainFooter,
    SlimNavbar,
  },
  data() {
    return {
      showSidebar: false,
      sidebarItems: getSidebarItems()
    };
  },
  computed: {
    route_name() {
      return this.$route.name;
    }
  },
  watch: {
    route_name() {
      this.showSidebar = false;
    }
  },
  created() {
    this.$store.dispatch("profile/initProfile");
  },
  methods: {
    handleToggleSidebar() {
        this.showSidebar = !this.showSidebar;
    }
  }
};
</script>
